import { Button, Card, Flex, Typography } from 'antd';

import IconLogo from '@/assets/icons/logo.svg?react';
import IconReload from '@/assets/icons/reload.svg?react';

const { Title, Text } = Typography;

export function CommonError() {
  return (
    <Card variant="borderless" className="ant-card-error">
      <Flex vertical align="center" flex={1}>
        <IconLogo width={120} height={41} />
        <Title level={1} className="mt-40">
          システムエラーが発生しました
        </Title>
        <Text className="mt-24">ブラウザを再読み込みしてください。</Text>
        <Button
          className="mt-24"
          icon={<IconReload />}
          onClick={() => globalThis.location.reload()}
        >
          再読み込み
        </Button>
      </Flex>
    </Card>
  );
}
